export default function (Component) {
Component.options.__title = "6-col grid"
}